<template>
    <CommonList
            selection-type="radio"
            row-key="roleId"
            :has-more-search="false"
            :auto-load="true"
            ref="listRef"
            cellOverflow="ellipsis"
            @selection-change="handleSelectionChange"
            @current-row-change="handleCurrentRowChange"
            @load-start="handleLoadList"
            @search-click="handleLoadList"
            @pagination-change="handleLoadList"
            @reset-click="handleReset"
    >
        <!-- 固定搜索区 -->
        <template #search-item-fixed>
            <div class="common-search-item">
                <label class="common-search-label80">角色ID：</label>
                <el-input v-model="searchForm.roleId" class="common-input120" placeholder="请输入角色ID"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">角色名称：</label>
                <el-input v-model="searchForm.roleName" class="common-input120" placeholder="请输入角色名称"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">是否生效：</label>
                <el-select v-model="searchForm.isDeleted" class="common-input100" placeholder="请选择">
                    <el-option label="是" value="0"></el-option>
                    <el-option label="否" value="1"></el-option>
                </el-select>
            </div>
        </template>

        <!-- 展开搜索区 -->
<!--        <template #search-item-expand>-->
<!--            <div class="common-search-item">-->
<!--                <label class="common-search-label80">创建时间：</label>-->
<!--                <el-date-picker-->
<!--                        v-model="searchForm.createTime"-->
<!--                        type="date"-->
<!--                        placeholder="请选择创建时间"-->
<!--                        class="common-date150"-->
<!--                ></el-date-picker>-->
<!--            </div>-->
<!--            <div class="common-search-item">-->
<!--                <label class="common-search-label80">更新时间：</label>-->
<!--                <el-date-picker-->
<!--                        v-model="searchForm.updateTimeRange"-->
<!--                        type="datetimerange"-->
<!--                        range-separator="至"-->
<!--                        start-placeholder="开始时间"-->
<!--                        end-placeholder="结束时间"-->
<!--                        format="YYYY-MM-DD"-->
<!--                        value-format="YYYY-MM-DD"-->
<!--                        class="common-date300"-->
<!--                ></el-date-picker>-->
<!--            </div>-->
<!--        </template>-->

        <!-- 操作按钮 -->
        <template #btn-group>
            <el-button type="primary" class="list-btn" @click="handleAdd">
                <el-icon>
                    <Plus/>
                </el-icon>
                新增角色
            </el-button>
            <el-button
                    type="warning"
                    class="list-btn"
                    @click="handleEdit"
                    :disabled="!selectedRow"
            >
                <el-icon>
                    <Edit/>
                </el-icon>
                修改角色
            </el-button>
            <el-button
                    type="danger"
                    class="list-btn"
                    @click="handleDelete"
                    :disabled="!selectedRow || selectedRow?.value?.isDeleted === 0"
            >
                <el-icon>
                    <Delete/>
                </el-icon>
                删除角色
            </el-button>
        </template>

        <!-- 表格列 width="auto" 占剩余宽度 :resizable="false" 不可拖拽-->
        <template #table-column>
            <el-table-column prop="roleId" label="角色ID" align="center" width="120"></el-table-column>
            <el-table-column prop="roleName" label="角色名称" align="center" width="180"></el-table-column>
            <el-table-column prop="roleDesc" label="角色描述" align="center" min-width="200"></el-table-column>
            <el-table-column prop="isDeleted" label="是否生效" align="center" width="100" >
                <template #default="scope">
                    <el-tag :class="scope.row.isDeleted == 0? 'list-status-normal' : 'list-status-deleted'">
                        {{ scope.row.isDeleted == 0? '是' : '否' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="配置菜单" align="center" width="auto" :resizable="false">
                <template #default="scope">
                    <el-button
                            type="primary"
                            size="small"
                    :disabled="scope.row.isDeleted !== 0"
                    @click="handleConfigMenu(scope.row)">
                    配置
                    </el-button>
                </template>
            </el-table-column>
        </template>

        <!-- 新增/编辑弹窗 -->
        <template #extra>
            <el-dialog
                    v-model="dialogVisible"
                    :title="dialogType === 'add' ? '新增角色' : '修改角色'"
                    width="500px"
                    destroy-on-close
            >
                <el-form
                        ref="formRef"
                        :model="formData"
                        :rules="formRules"
                        label-width="100px"
                        class="list-modal-form"
                >
                    <el-form-item label="角色ID" prop="roleId">
                        <el-input
                                v-model="formData.roleId"
                                :disabled="dialogType === 'edit'"
                                placeholder="请输入角色ID"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="角色名称" prop="roleName">
                        <el-input
                                v-model="formData.roleName"
                                placeholder="请输入角色名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="是否生效" prop="isDeleted">
                        <el-radio-group v-model="formData.isDeleted">
                            <el-radio :label=0>是</el-radio>
                            <el-radio :label=1>否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="角色描述" prop="roleDesc">
                        <el-input
                                v-model="formData.roleDesc"
                                type="textarea"
                                :rows="3"
                                placeholder="请输入角色描述"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <template #footer>
                    <div style="text-align: center; width: 100%;">
                        <el-button @click="dialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="handleSubmit">确定</el-button>
                    </div>
                </template>
            </el-dialog>

            <el-dialog
                    v-model="configMenuDialogVisible"
                    title="菜单配置"
                    width="600px"
                    destroy-on-close
            >
                <el-tree
                        ref="menuTreeRef"
                        :data="menuTreeData"
                        :props="treeProps"
                        show-checkbox
                        node-key="menuId"
                        :checked-keys="checkedMenuKeys"
                        class="menu-tree"
                ></el-tree>
                <template #footer>
                    <div style="text-align: center; width: 100%;">
                        <el-button @click="configMenuDialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="handleConfigMenuSubmit">提交</el-button>
                    </div>
                </template>
            </el-dialog>
        </template>
    </CommonList>
</template>

<script setup>
    import useRoleList from './roleList.js';
    //暴露树组件供js使用 判断树组件渲染完成后再 初始化 check
    import { ref } from 'vue';
    const menuTreeRef = ref(null);
    const {
        searchForm,
        listRef,
        dialogVisible,
        dialogType,
        formRef,
        selectedRow,
        formData,
        formRules,
        Plus, Edit, Delete,
        handleSelectionChange,
        handleCurrentRowChange,
        handleAdd,
        handleEdit,
        handleDelete,
        handleSubmit,
        handleLoadList,
        handleReset,
        handleConfigMenu,
        configMenuDialogVisible,
        menuTreeData,
        treeProps,
        handleConfigMenuSubmit,
        checkedMenuKeys
    } = useRoleList(menuTreeRef);
</script>

<style>
    @import '../../../assets/css/util/base-list.css';

</style>
<style scoped>
    /* 菜单树样式优化 */
    .menu-tree {
        max-height: 400px;
        overflow-y: auto;
        padding: 10px;
    }
</style>
